import { getField, updateField } from 'vuex-map-fields';
import OnlineScheduling from '../../api/online-scheduling';

// initial state
const state = {
    loading: true,
    step: 1,
    appointmentType: 'FollowUp',
    clinic: null,
    patient: null,
    timeslot: null,
    appointments: [],
    companionTypes: [],
    globals: {
        changeLocations: 'locations',
        returnToHomepage: '',
    }
};

// getters
const getters = {
    getField
};

// actions
const actions = {
    getClinicInformation({ commit, rootState }, { ClinicUrl, ClientToken, cb }) {
        OnlineScheduling.getClinicInformation((data) => {
            commit('setStateValue', { key: 'clinic', value: data.data[0] });
            if (cb) {
                cb();
            }
        }, { ClinicUrl, ClientToken });
    },
    getAppointmentTimeslots({ commit, rootState }, { StartDate, EndDate, AppointmentType, ClinicId, ClientToken, cb }) {
        OnlineScheduling.getAppointmentTimeslots((data) => {
            commit('setStateValue', { key: 'appointments', value: data });
            if (cb) {
                cb();
            }
        }, { StartDate, EndDate, AppointmentType, ClinicId, ClientToken });
    },
    getCompanionTypes({ commit, rootState }, { ClientToken, cb }) {
        OnlineScheduling.getCompanionTypes((data) => {
            commit('setStateValue', { key: 'companionTypes', value: data });
            if (cb) {
                cb();
            }
        }, { ClientToken });
    },
    postScheduleAppointment({ commit, rootState }, { data, ClientToken, cb }) {
        OnlineScheduling.postScheduleAppointment((data) => {
            if (cb) {
                cb();
            }
        }, { data, ClientToken });
    },
    updateTimeslot({ commit, rootState }, val) {
        commit('setStateValue', { key: 'timeslot', value: val });
    },
    updatePatient({ commit, rootState }, val) {
        commit('setStateValue', { key: 'patient', value: val });
    },
    updateStep({ commit, rootState }, val) {
        commit('setStateValue', { key: 'step', value: val });
    },
    updateLoading({ commit, rootState }, val) {
        commit('setStateValue', { key: 'loading', value: val });
    },
    updateAppointmentType({ commit, rootState }, val) {
        commit('setStateValue', { key: 'appointmentType', value: val });
    },
};

// mutations
const mutations = {
    updateField,
    setStateValue(state, payload) {
        state[payload.key] = payload.value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
